import { FC } from "react";

import {
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface IROEWebInfoFieldsPanel { 

}
export const ROEWebInfoFieldsPanel: FC<
	IROEWebInfoFieldsPanel
> = ({ 
	
}) => {
	const theme = useTheme();
	return (
		<Box
		>
			<EnhancedDropDownRHFWithLabel
				label="Web Processing Method"
				selectName="webProcessingMethod"
				testId={`web-processing-method`}
				labelPosition={LabelPosition.Top}
				items={[
					{
						label: "Store as Draft",
						value: 100,
					},
					{
						label: "To be Submitted",
						value: 200,
					},
				]}
			/>

			<RHookFormTextFieldWithLabel
				label="File Name"
				id="fileName"
				testId={`file-name`}
				labelPosition={LabelPosition.Top}
			/>
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", marginBottom: "5px" }}
			>
				<span style={{ height: "10px", width: "10px", background: "#E5FFE8" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
				<span>Submitted to Service Canada</span>
				<br />
				<span style={{ height: "10px", width: "10px", background: "#FFFAE5" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
				<span>File Generated</span>
				<br />
				<span style={{ height: "10px", width: "10px", background: "#F6E5FF" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
				<span>Ready to Generate ROE Web file.</span>
				<br />
				<span style={{ height: "10px", width: "10px", background: "#F6E5FF" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
				<span>ROE not created.</span>

			</Grid>
			<Typography>
				<Link
				to={"#"}
				className="no-underline"
				style={{ color: theme.palette.primary.light }}
				>
				<span
					style={{
						color: "#0091b3",
						fontSize:".875rem",
						
					}}>
					To register/login for ROE Web
				</span>
				</Link>
			</Typography>
		</Box>
	);
};
